'use strict';

window.dataLayer = window.dataLayer || [];

var productDataExtractorFactory = function () {
    this.createExtractor = function (type) {
        var productExtractor;

        if (type == 'weightedProduct') {
            productExtractor = new extractWeightedProductData();
            productExtractor.type = type;
        } else if (type == 'default') {
            productExtractor = new extractDefaultProductData();
            productExtractor.type = type;
        } else {
            productExtractor = new extractDefaultProductData();
            productExtractor.type = 'default';
        }

        return productExtractor;
    };
};

var extractWeightedProductData = function () {
    this.extractGA4 = function ($product, quantityAddedOrRemoved, firstAddOrDeleteAction) {
        var sku = $product.data('product-code'),
            name = $product.data('product-name-en') ? $product.data('product-name-en') : $product.data('product-name'),
            brand = $product.data('product-brand'),
            category = $product.data('product-category-en') ? $product.data('product-category-en') : $product.data('product-category'),
            qty = $product.data('qty') ? getWeightedProductQuantity($product, $product.data('qty'), $product.data('min-qty'), $product.data('unit-increment')) : 1,
            price = getWeightedProductUnitPrice($product, qty),
            listName = $product.data('product-list-name') ? $product.data('product-list-name') : $product.closest("[data-list-name]").attr('data-list-name');

        var productData = {
            item_name: name != null ? name : '',
            item_id: sku != null ? sku : '',
            price: price,
            item_brand: brand != null ? brand : '',
            item_category: category != null ? category : '',
            quantity: qty,
            item_list_name: listName
        };

        if (!!quantityAddedOrRemoved && quantityAddedOrRemoved == 1) {
            productData.quantity = quantityAddedOrRemoved;
        }

        // Same quantity on first add as in the mini-cart and cart should be the same when it is removed
        if (firstAddOrDeleteAction) {
            productData.quantity = $product.data('min-qty') / $product.data('unit-increment');
        }
        if (listName === 'cartGenius' && $product.data('genius-qty')) {
            productData.quantity = getCartGeniusProductQuantity($product);
        }
        return productData;
    };
};

function computeVariantField(variantPrice, selectedOption) {
    var variant = '';
    if (variantPrice != null) {
        variant += variantPrice;
    }

    if (selectedOption != '') {
        if (variant != '') {
            variant += ' | ' + selectedOption;
        } else {
            variant += selectedOption;
        }
    }
    return variant;
}

var extractDefaultProductData = function () {
    this.extractGA4 = function ($product, quantityAddedOrRemoved) {
        var sku = $product.data('product-code'),
            name = $product.data('product-name-en') ? $product.data('product-name-en') : $product.data('product-name'),
            brand = $product.data('product-brand'),
            category = $product.data('product-category-en') ? $product.data('product-category-en') : $product.data('product-category'),
            price = $product.find('[data-main-price]').length ? $product.find('[data-main-price]').attr('data-main-price') : $product.attr('data-main-price'),
            qty = $product.data('qty'),
            isInactive = $product.data('is-inactive'),
            listName = $product.data('product-list-name') ? $product.data('product-list-name') : $product.closest("[data-list-name]").attr('data-list-name');

        var productData = {
            item_name: name != null ? name : '',
            item_id: sku != null ? sku : '',
            price: price,
            item_brand: brand != null ? brand : '',
            item_category: category != null ? category : '',
            quantity: qty,
            out_of_stock: isInactive,
            item_list_name: listName
        };

        if (!!quantityAddedOrRemoved) {
            productData.quantity = quantityAddedOrRemoved;
        }
        return productData;
    };
};

var ga4_create_product_data = function ($product, productData, listName) {
    if (listName != null) {
        productData.item_list_name = listName;
    }

    return productData;
};

var ga4_create_product_data_with_listName_undefined = function (productData) {
    // dans le cas de refund item_list_name = undefined
    productData.item_list_name = undefined;

    return productData;
};

var extractDimensions = function ($product, productData) {
    var dimension8 = ($product.find("[data-dimension-8]")).first().attr('data-dimension-8'),
        dimension9 = ($product.find("[data-dimension-9]")).first().attr('data-dimension-9'),
        dimension10 = ($product.find('.select-addToCart .activeOption')).text(),
        dimension12 = $product.data('dimension-twelve');

    productData.dimension8 = dimension8 != null ? dimension8 : '';
    productData.dimension9 = dimension9 != null ? dimension9 : '';
    productData.dimension10 = dimension10 != null ? dimension10 : '';
    productData.dimension12 = dimension12 != null ? dimension12 : '';

    return productData;
};

function isProductInfoPresent(productData) {
    return productData.id != '' || productData.name != '' || productData.price != '' || productData.variant != '';
}

var buildGtmEventLabel = function (labelPrefix, labelMiddle, labelSuffix) {
    return [labelPrefix, labelMiddle, labelSuffix].filter(Boolean).join(' | ');
};

window['push_product_click_metrics'] = function ($product, listName) {
    var productType = ($product.data('is-weighted') == true) ? 'weightedProduct' : 'default';
    var ga4ProductData = (new productDataExtractorFactory()).createExtractor(productType).extractGA4($product);
    var ga4EventData = {
        event: 'ga4_select_item',
        ecommerce: {
            items: [
                ga4_create_product_data($product, ga4ProductData, listName)
            ]
        }
    };

    pushTrackingEventToAppropriateContainer(null, ga4EventData, true);
};

window['push_product_detail_metrics'] = function () {
    var $product = $('.productPDP');
    var productType = ($product.data('is-weighted') == true) ? 'weightedProduct' : 'default';

    var listName = $product.closest('[data-list-name]').attr('data-list-name');
    if (listName === "productDetail" && sessionStorage.getItem("productsListName")) {
        // get the ga4_view_item's item_list_name
        var productListName = getItemListNameFromSessionStorage("productsListName", $product);
        // check if listName is not undefined and not null
        if (productListName) {
            listName = productListName;
            $product.closest('[data-list-name]').attr('data-list-name', listName);
        }
    }

    var ga4ProductData = (new productDataExtractorFactory()).createExtractor(productType).extractGA4($product);
    var ga4EventData = {
        event: 'ga4_view_item',
        ecommerce: {
            items: [
                ga4_create_product_data($product, ga4ProductData, listName)
            ]
        }
    };

    pushTrackingEventToAppropriateContainer(null, ga4EventData, true);
};

window['push_add_cart_info_metrics'] = function ($product, quantityAdded, actionList, firstAddAction) {
    var productType = ($product.data('is-weighted') == true) ? 'weightedProduct' : 'default';
    var ga4ProductData = (new productDataExtractorFactory()).createExtractor(productType).extractGA4($product, quantityAdded, firstAddAction);
    var ga4EventData = {
        event: 'ga4_add_to_cart',
        ecommerce: {
            items: [
                ga4_create_product_data($product, ga4ProductData, actionList)
            ]
        }
    };

    pushTrackingEventToAppropriateContainer(null, ga4EventData, true);
};

window['push_remove_cart_info_metrics'] = function ($product, quantityRemoved, deleteAction) {
    var productType = ($product.data('is-weighted') == true) ? 'weightedProduct' : 'default';
    var productData = (new productDataExtractorFactory()).createExtractor(productType).extractGA4($product, quantityRemoved, deleteAction);
    var listName = $product.data('product-list-name');
    var ga4EventData = {
        event: 'ga4_remove_from_cart',
        ecommerce: {
            items: [
                ga4_create_product_data($product, productData, listName !== null ? listName : '')
            ]
        }
    };

    pushTrackingEventToAppropriateContainer(null, ga4EventData, true);
};

window['push_search_result_metrics'] = function (keyword, totalResults, isDidYouMeanTextSearch) {
    var searchCategory = 'global';
    var searchCategoryGA4 = 'product';
    var searchCaseGA4 = 'with results';

    if (totalResults == 0) {
        searchCaseGA4 = 'without results';
    } else if (isDidYouMeanTextSearch && searchCategory !== 'global') {
        searchCategoryGA4 = 'suggestion';
    }

    var ga4EventData = {
        event: 'ga4Event',
        eventName: 'search',
        search_term: keyword,
        search_category: searchCategoryGA4,
        search_case: searchCaseGA4,
        search_nb_results: totalResults
    };

    pushTrackingEventToAppropriateContainer(null, ga4EventData, false);
};

window['pushCheckoutProductsMetrics'] = function (target, step, action, fromCart) {
    if (fromCart) {
        var ga4EventData = {
            event: 'ga4_begin_checkout',
            ecommerce: {}
        };

        _addProducts(target, ga4EventData);
        pushGA4TrackingEventOnly(ga4EventData, true);
    } else {
        var ga4StepName = getCheckoutStepNameGa4Event(step);
        var ga4EventData = {
            event: 'ga4Event',
            eventName: ga4StepName,
        };

        pushTrackingEventToAppropriateContainer(null, ga4EventData, false);
    }

    if (typeof action === 'function') {
        action();
    }
};

window['pushOrderMetrics'] = function () {
    var $orderGroceryInfo = $('#orderInfoGrocery');
    if ($orderGroceryInfo.length) {
        var ga4Products = _getProductsForOrderOrCheckout('#cartSummaryOnlineGrocery .product-card--checkout');
        let redeemTotal = 0;
        $("[data-reward-amount]").each(function (index) {
            let redeemAmount = $(this).data('reward-amount');
            if (redeemAmount)
                redeemTotal += redeemAmount;
        })
        var ga4EventData = {
            event: 'ga4_purchase',
            ecommerce: {
                transaction_id: $('#dataLayerOrderConfirmationNumGrocery').text(),
                affiliation: $orderGroceryInfo.data('store-name'),
                currency: 'CAD',
                value: $orderGroceryInfo.data('total'),
                tax: $orderGroceryInfo.data('tax'),
                shipping: $orderGroceryInfo.data('fees'),
                coupon: $orderGroceryInfo.data('ga4-promo-codes'),
                redeem_amount: Number(redeemTotal),
                delivery_method: $orderGroceryInfo.data('order-service'),
                delivery_delay: $orderGroceryInfo.data('order-delay'),
                delivery_timeslot: $('.orderDate').first().data('ga4-timeslot-day') + ' ' + $('.orderTime').first().text(),
                tip_amount: $orderGroceryInfo.data('tip-amount'),
                items: ga4Products
            }
        };

        pushTrackingEventToAppropriateContainer(null, ga4EventData, true);
    }
};

window['pushOrderUpdateMetrics'] = function () {
    _push_custom_event_to_GA4('order_modification');
};

window['pushReorderProductsMetrics'] = function ($products) {
    if ($products) {
        $products.each(function () {
            var $product = $(this);
            push_add_cart_info_metrics($product, $product.attr('data-qty'), 'reorder'); // One event per product. Asked by metrics team.. TODO Optimize this using an array of items
        });
    }
};

window['pushRefundOrderMetrics'] = function () {
    var ga4EventData = {
        event: 'ga4_refund',
        ecommerce: {
            transaction_id: $('.dataLayerOrderConfirmationNumRefund').text(),
            refund_case: 'Full'
        }
    };

    pushTrackingEventToAppropriateContainer(null, ga4EventData, true);
};

window['pushOrderRefundProductMetrics'] = function (productTile, sku, qty, reason) {
    var productType = (productTile.data('is-weighted') == true) ? 'weightedProduct' : 'default';
    var productData = (new productDataExtractorFactory()).createExtractor(productType).extractGA4(productTile);
    var ga4EventData = {
        event: 'ga4_refund_partial',
        ecommerce: {
            transaction_id: $('.dataLayerOrderConfirmationNumRefund').text(),
            refund_case: 'Partial',
            refund_reason: reason,
            items: [
                ga4_create_product_data_with_listName_undefined(productData)
            ]
        }
    };

    pushTrackingEventToAppropriateContainer(null, ga4EventData, true);
};

window['pushAddProductToCartStarterMetrics'] = function ($product, productCode, listName) {
    var productType = ($product.data('is-weighted') == true) ? 'weightedProduct' : 'default';
    var ga4ProductData = (new productDataExtractorFactory()).createExtractor(productType).extractGA4($product, 1);
    var ga4EventData = {
        event: 'ga4_add_to_wishlist',
        ecommerce: {
            items: [
                ga4_create_product_data($product, ga4ProductData, listName)
            ]
        }
    };

    pushTrackingEventToAppropriateContainer(null, ga4EventData, true);
};

function _addProducts(target, ga4Data) {
    var ga4Products = _getProductsForOrderOrCheckout(target);
    if (ga4Products.length > 0) {
        ga4Data.ecommerce.items = ga4Products;
    }
}

function _getProductsForOrderOrCheckout(target) {
    var $rawProducts = $(target);
    var products = [];

    $rawProducts.each(function () {
        var productType = ($(this).data('is-weighted') == true) ? 'weightedProduct' : 'default';
        var productData = (new productDataExtractorFactory()).createExtractor(productType).extractGA4($(this));
        var listName = $(this).data('product-list-name');
        products.push(ga4_create_product_data($(this), productData, listName !== null ? listName : ''));
    });

    return products;
}

function _getProductsInCart(target) {
    var $rawProducts = $(target);
    var products = [];

    $rawProducts.each(function () {
        var productType = ($(this).data('is-weighted') == true) ? 'weightedProduct' : 'default';
        var productData = (new productDataExtractorFactory()).createExtractor(productType).extractGA4($(this));
        var listName = $(this).data('product-list-name');
        products.push(ga4_create_product_data($(this), productData, listName !== null ? listName : ''));
    });

    return products;
}

var _push_event_to_google = function (category, action, label) {
    pushGtmTrackingEventOnly({
        event: 'GAEvent',
        eventCategory: category,
        eventAction: action,
        eventLabel: label
    });
};

var _push_custom_event_to_GA4 = function () {
    if (arguments.length < 1) {
        console.error('Please specify at least the first parameter for eventName.');
        return;
    } else if (arguments.length % 2 === 0) {
        console.error('The number of arguments must be odd. Arguments should be as followed: eventName, (param1, value1, param2, value2...). Keys/values are optional');
        return;
    }

    let pushContent = {
        event: 'ga4Event',
        'eventName': arguments[0]
    }

    if (arguments.length > 1) {
        for (let i = 1; i < arguments.length; i += 2) {
            pushContent[arguments[i]] = arguments[i + 1];
        }
    }

    pushGA4TrackingEventOnly(pushContent, false);
};

function pushDataLayerStoreDetailsGetDirections() {
    _push_custom_event_to_GA4('store_directions');
}

function _tryToAddTimeslotSelection(data) {
    var optionPickup = $('#selected-time-slot').data('for-pickup');
    if (optionPickup) {
        data.ecommerce.checkout.actionField.option = 'pickup';
    } else {
        data.ecommerce.checkout.actionField.option = 'delivery';
    }
}

function _tryToAddPaymentSelection(data) {
    var payment = $('.checkout-saved-payment.selected').data('payment-method');
    if (!!payment) {
        data.ecommerce.checkout.actionField.option = payment;
    }
}

function pushDatalayerCouponClip(btn) {
    let cBanner = $(btn).parent().attr('data-cBanner');
    let cTypeId = $(btn).parent().attr('data-cTypeId');
    if ($(btn).hasClass("card-clip") && $(btn).hasClass("available")) {
        _push_custom_event_to_GA4(
            'coupon_clip',
            'coupon_id', cTypeId,
            'coupon_banner_name', cBanner
        );
    }
}

function pushDataLayerCouponDisplay(program, couponId) {
    var ga4EventData = {
        event: 'ga4Event',
        eventName: 'coupon_view',
        coupon_id: couponId
    };

    pushTrackingEventToAppropriateContainer(null, ga4EventData, false);
}

function pushDataLayerSubstitutionChanged(event) {
    const checkbox = $(event?.target).closest('input[type=checkbox]');
    if (checkbox.length) {
        _push_custom_event_to_GA4(
            'product_substitution_toggle',
            'description', checkbox.is(':checked') ? 'on' : 'off'
        );
    }
}

function pushDataLayerNewsletterOptIn(newsletterName) {
    var ga4EventData = {
        event: 'ga4Event',
        eventName: 'newsletter_subscribe',
        newsletter_name: newsletterName
    };

    pushTrackingEventToAppropriateContainer(null, ga4EventData, false);
}

function pushDataLayerRecipe(action, label, event) {
    pushGtmTrackingEventOnly({
        event: event ? event : 'GAEvent',
        eventCategory: 'recipes and occasions',
        eventAction: action,
        eventLabel: label
    });
}

// CATALOG
function pushDataLayerProductCatalogFilterBy(origin, selectedFiltersCategory, selectedFiltersOption) {
    _push_custom_event_to_GA4(
        'aisles_filter',
        'origin', origin,
        'description', selectedFiltersCategory + ' | ' + selectedFiltersOption
    );
}

// MY-CART / CHECKOUT

function pushDataLayerEditOrderFromConfirmation() {
    _push_custom_event_to_GA4('order_modification_intent');
}

function pushDataLayerFirstOrder() {
    _push_custom_event_to_GA4('first_purchase');
}

function pushDataLayerCheckoutFirstStepSeen(step) {
    if (step && !isNaN(step)) {
        var stepNameGA4 = getCheckoutStepNameGA4(step);
        if (stepNameGA4 !== '') {
            _push_custom_event_to_GA4('checkout_first_step_view', 'checkout_landing_step', stepNameGA4);
        }
    }
}

function pushDataLayerOrderHistoryConfirmOrderChange() {
    _push_custom_event_to_GA4('order_modification_intent');
}

function pushDataLayerSignUpSignInValidate(eventName, ga4UserFidelitySegment, ga4UserEcomSegment, ga4UserLoyaltyProgram, user_is_metro_buyer, subjectId) {
   let bannerBuyerString = 'user_is_metro_buyer';

   if (bannerCode === 'superc') {
       bannerBuyerString = 'user_is_superc_buyer';
   } else if (bannerCode === 'foodbasics') {
       bannerBuyerString = 'user_is_foodbasics_buyer';
   }

    _push_custom_event_to_GA4(
        eventName,
        'user_segment_fidelity', ga4UserFidelitySegment,
        'user_segment_ecom', ga4UserEcomSegment,
        'user_fidelity_program', ga4UserLoyaltyProgram,
        bannerBuyerString, user_is_metro_buyer,
        'user_id', subjectId);
}

function pushDataLayerLinkingCardErrorAccountCreation(userLoyaltyProgram, errorMsg) {
    _push_custom_event_to_GA4('error_message', 'error_description', 'card linking | ' + errorMsg);
}

function pushDataLayerLinkingCardErrorMyAccount(userLoyaltyProgram, errorMsg) {
    _push_custom_event_to_GA4('error_message', 'error_description', 'card linking | ' + errorMsg);
}

function pushDataLayerBigMenuLevel(menuName, subMenuLabel) {
    _push_custom_event_to_GA4(menuName, 'description', "aisles" + ' | ' + subMenuLabel);
}

// Service and timeslot
const gaPushOnPanelView = function (originOfPanel, serviceType, timeslotType, availability) {
    _push_custom_event_to_GA4(
        'service_ts_side_panel_view',
        'type', serviceType + ' - ' + timeslotType + ' timeslots',
        'origin', originOfPanel,
        'availability', availability);
}

const gaNoCompletePostalCodePushOnPanelView = function (originOfPanel, serviceType, availability) {
    _push_custom_event_to_GA4(
        'service_ts_side_panel_view',
        'type', serviceType,
        'origin', originOfPanel,
        'availability', availability);
}

const gaNoCompletePostalCodePushOnPanelClose = function (serviceType, availability) {
    _push_custom_event_to_GA4(
        'service_ts_side_panel_close',
        'type', serviceType,
        'availability', availability);
}

const gaPushOnPanelServiceClick = function (elmText, serviceType, partnerType, timeslotType) {
    _push_custom_event_to_GA4(
        'service_ts_side_panel_click',
        'type', serviceType + ' - ' + timeslotType + ' timeslots',
        'partner', partnerType,
        'link_text', elmText);
}

const gaPushOnPanelClose = function (serviceType, timeslotType, availability) {
    _push_custom_event_to_GA4(
        'service_ts_side_panel_close',
        'type', serviceType + ' - ' + timeslotType + ' timeslots',
        'availability', availability);
}

const gaPushOnOverlayView = function () {
    _push_custom_event_to_GA4('service_ts_overlay_view');
}

const gaPushOnOverlayClose = function () {
    _push_custom_event_to_GA4('service_ts_overlay_close');
}

const gaPushOnOverlayClick = function (linkText, serviceType, timeslotType) {
    let type = typeof serviceType != 'undefined' && typeof timeslotType != 'undefined' ? serviceType + ' - ' + timeslotType + ' timeslots' : undefined;
    _push_custom_event_to_GA4(
        'service_ts_overlay_click',
        'link_text', linkText,
        'type', type);
}

function pushDataLayerAccountDeleteEntent() {
    _push_custom_event_to_GA4(
        'delete_account_intent',
        'description', bannerCode + ' account deletion'
    );
}

function pushDatalayerMoiIdDleteIntent() {
    _push_custom_event_to_GA4(
        'delete_account_intent',
        'description', 'moi id deletion'
    );
}

function pushDataLayerLinkingCardErrorMyAccountMetrics(errorMsg) {
    _push_custom_event_to_GA4('error_message', 'error_description', 'card linking | ' + errorMsg);
}

function pushDataLayerCardCreateIntent() {
    _push_custom_event_to_GA4('card_create_intent');
}

function pushDataLayerNewsletterSubsFromPreference(checkedCheckboxId) {
    if (checkedCheckboxId === "consentBannerComm1") pushCustomEventToGA4("Metro");
    else if (checkedCheckboxId === "consentComm1") pushCustomEventToGA4("moi");
}

function pushCustomEventToGA4(newsletterName) {
    _push_custom_event_to_GA4(
        'newsletter_subscribe',
        'newsletter_name', newsletterName,
        'origin', 'communication preferences'
    );
}

function pushDatalayerDeactivateCard() {
    _push_custom_event_to_GA4(
        'card_disable',
        'description', 'other'
    );
}

function pushLinkCardStepMetrics(step) {
    if (step && !isNaN(step)) {
        _push_custom_event_to_GA4(
            'card_link_intent',
            'step', step + '/3');
    }
}

function pushDataLayerOrderModificationIntent() {
    _push_custom_event_to_GA4(
        'order_modification_intent'
    );
}

function pushDataLayerReceiptSubscription() {
    _push_custom_event_to_GA4(
        'e_receipt_subscribe'
    );
}

function ga4ViewCart() {
    var $productContainer = $('.mini--cart--product').length ? $('.mini--cart--product') : $('.product-card');
    var products = _getProductsInCart($productContainer);
    var ga4EventData = {
        event: 'ga4_view_cart',
        ecommerce: {
            items: products
        }
    };
    pushGA4TrackingEventOnly(ga4EventData, true);
}

window['push_remove_all_from_cart_info_metrics'] = function ($products) {
    var ga4ProductsToSend = [];
    $products.each(function () {
        var productType = ($(this).data('is-weighted') == true) ? 'weightedProduct' : 'default';
        var ga4Product = (new productDataExtractorFactory()).createExtractor(productType).extractGA4($(this));
        var listName = $(this).data('product-list-name');
        ga4ProductsToSend.push(ga4_create_product_data($(this), ga4Product, listName !== null ? listName : ''));
    });

    var ga4EventData = {
        event: 'ga4_remove_from_cart',
        ecommerce: {
            items: ga4ProductsToSend
        }
    };

    pushTrackingEventToAppropriateContainer(null, ga4EventData, true);
};

function getCheckoutStepNameGA4(step) {
    var ga4StepLabel = '';
    if (step === 1) {
        ga4StepLabel = 'step-1_services';
    } else if (step === 2) {
        ga4StepLabel = 'step-2_account';
    } else if (step === 3) {
        ga4StepLabel = 'step-3_payment';
    } else if (step === 5) {
        ga4StepLabel = 'step-4_order-review';
    }
    return ga4StepLabel;
}

// -------------------------------------------------------------------------
// Tracking events in the mobile app should be consistent with GA4 tracking events on website (same data).
// For webviews, the tracking data is sent to mobile app with postMessage. Never send anything to the datalayer in webview mode.
// Use pushTrackingEventToAppropriateContainer to manage the push to mobile app or datalayer according to context.
// -------------------------------------------------------------------------

function sendTrackingEventToDevice(eventData) {
    sendWebviewEventToDevice("trackEvent", {eventData: eventData});
}

function pushTrackingEventToAppropriateContainer(gtmEventData, ga4EventData, pushEmptyEcommerceBeforeGA4) {
    if (isInWebview()) {
        if (ga4EventData) {
            sendTrackingEventToDevice(ga4EventData);
        }
    } else {
        if (gtmEventData) {
            dataLayer.push(gtmEventData);
        }

        if (ga4EventData) {
            dataLayer = window.dataLayer || [];

            if (typeof pushEmptyEcommerceBeforeGA4 !== 'undefined' && pushEmptyEcommerceBeforeGA4) {
                dataLayer.push({ecommerce: null});
            }

            dataLayer.push(ga4EventData);
        }
    }
}

function pushGtmTrackingEventOnly(gtmEventData) {
    pushTrackingEventToAppropriateContainer(gtmEventData, null, false);
}

function pushGA4TrackingEventOnly(ga4EventData, pushEmptyEcommerceBeforeGA4) {
    pushTrackingEventToAppropriateContainer(null, ga4EventData, pushEmptyEcommerceBeforeGA4);
}

function pushHotJarEvent(event) {
    if (typeof hj === 'function') { // might be blocked by ad-blocker extensions
        hj('trigger', event);
    }
}

function getItemListNameFromSessionStorage(storageProductList, $product) {
    var storageProductsListName = JSON.parse(sessionStorage.getItem(storageProductList));
    if (storageProductsListName) {
        var sku = $product.data('product-code');
        var lastItem = storageProductsListName.slice().reverse().find(item => item.productId === sku);
        if (lastItem)
            return lastItem.productListName;
    }
}

function getWeightedProductUnitPrice($product, qty) {
    var totalePrice = $product.hasClass('mini--cart--product') ? $product.data("subtotal-price") : $product.find("[data-subTotal-price]").attr('data-subTotal-price');
    if (!totalePrice) {
        // GA4_add_to_ cart Prendre en considération les prix pour les produits de type 'weighted', où le prix dépend d'une liste déroulante (prix/poids) dans le format suivant: x $ env. ch.
        let priceUpdate = $product.find('.price-update');
        let priceUpdateText = $product.hasClass('pdpDetailsContainer')
            ? priceUpdate.first().text()
            : priceUpdate.text();
        return priceUpdateText.replace(/\s*\$\s*/, "").replace(",", ".")

    } else {
        // traiter tous les types de produits, meme ceux avec selectedConfiguration
        return (totalePrice / qty).toFixed(2);
    }
}

function getWeightedProductQuantity($product, qty, minQty, increment) {
    // transform the weight of products to integer quantity
    if ($product && $product.data('ordered-qty') != null) {
        qty = $product.data('ordered-qty');
    }

    return qty / increment;
}

function getCheckoutStepNameGa4Event(step) {
    let ga4Step = step - 1; // In GA4, step 1 = services (while step 1 in UA is cart)
    if (ga4Step === 4) {
        ga4Step = "_sms";
    }

    //rename step_5_view to step_4_view as the previous step is now step_sms_view
    if(ga4Step === 5) {
        ga4Step = "4";
    }

    if(smsActivated === false && ga4Step >= 5) {
        ga4Step = "4";
    }

    return 'checkout_step' + ga4Step + '_view';
}

function pushEventCouponImpression(couponTypeId, couponBanner, couponExclusiveApp) {
    _push_custom_event_to_GA4(
        'coupon_view',
        'coupon_id', couponTypeId,
        'coupon_banner_name', couponBanner,
        'coupon_exclusif_app', couponExclusiveApp
    );
}

function pushEventSmartApp(isView, clickTrigger) {
    if (isView === true) {
        _push_custom_event_to_GA4 (
            'smart_app_banner_view'
        );
    } else {
        _push_custom_event_to_GA4 (
            'smart_app_banner_click',
            'description', clickTrigger
        );
    }
}

function getCartGeniusProductQuantity($product) {
    if ($product.data('genius-qty')) {
        return getWeightedProductQuantity(
            $product,
            $product.data('genius-qty'),
            $product.data('min-qty'),
            $product.data('unit-increment')
        );
    }
    return 1;
}

function pushDataLayerProductBrand($brand) {
    _push_custom_event_to_GA4(
        'brand_click',
        'description', $brand
    );
}